import Stack from '@mui/material/Stack';
import MenuItem from '@mui/material/MenuItem';
import Typography from '@mui/material/Typography';

import Iconify from 'src/components/iconify';

import { RecordAction } from './record-panel.types';

// ----------------------------------------------------------------------

/**
 * Renders a record's actions as menu items, for the profile Actions menu and the quick-view "More"
 * menu (JT1-1799). Hidden actions are dropped; the menu closes before the action runs, so a dialog
 * the action opens isn't fighting the popover for focus.
 */
export default function RecordActionMenuItems({ actions, onClose }: { actions: RecordAction[]; onClose: () => void }) {
  return (
    <>
      {actions.filter((action) => !action.hidden).map((action) => (
        <MenuItem
          key={action.key}
          disabled={action.disabled}
          onClick={() => {
            onClose();
            action.onClick();
          }}
        >
          <Iconify icon={action.icon} />
          {action.caption ? (
            <Stack>
              <Typography variant="body2">{action.label}</Typography>
              <Typography variant="caption" color="text.secondary">{action.caption}</Typography>
            </Stack>
          ) : (
            <Typography variant="body2">{action.label}</Typography>
          )}
        </MenuItem>
      ))}
    </>
  );
}
